import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';

import { fetchEmailTemplatesSendGrid } from 'src/actions/emailTemplatesSendGrid';

import Button from '../helpers/Button';
import { AppPage } from '../AppPage';
import { GridCard } from '../helpers/GridCard';
import { EmailTemplateTable } from './EmailTemplateTable';
import { EmailTemplateSendGridForm } from './EmailTemplateSendGridForm';
import { usePopupContext } from '../../contexts/PopupContext';

import style from './style.module.css';

const EmailTemplateSendGridManagementComponent = ({
  activities,
  isLoading,
  emailTemplates,
  onSortChange,
  emailTemplatesFilter,
  fetchEmailTemplatesSendGrid,
}) => {
  const { openPopup } = usePopupContext();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    if (id) {
      openPopup('EditEmailTemplateSendGridPopup', { idEmailTemplate: id });
    }
  }, []);

  const handleSearch = () => {
    fetchEmailTemplatesSendGrid({
      activity: emailTemplatesFilter.getIn(['activity', 'selected', 'value']),
      buyerId: emailTemplatesFilter.getIn(['buyer', 'buyer', 'selected', 'id']),
      projectId: emailTemplatesFilter.getIn(['buyer', 'project', 'selected', 'id']),
      templateName: emailTemplatesFilter.getIn(['templateName', 'value']),
    });
  };

  const handleAddTemplate = () => {
    openPopup('AddEmailTemplateSendGridPopup');
  };

  const toolbar = (
    <>
      <EmailTemplateSendGridForm activities={activities} emailTemplate={emailTemplatesFilter} formName="filter" />
      <Button className="btn-primary" onClick={handleSearch}>
        <i aria-hidden="true" className="fa fa-search" /> Search
      </Button>
      <div className={style.toolbar}>
        <Button onClick={handleAddTemplate}>
          <i aria-hidden="true" className="fa fa-plus" /> Add New
        </Button>
      </div>
    </>
  );

  return (
    <AppPage overline="Mailing" title="Sendgrid Email Templates" toolbar={toolbar}>
      <GridCard className={style.table} dense>
        <EmailTemplateTable emailTemplates={emailTemplates} isLoading={isLoading} onSortChange={onSortChange} />
      </GridCard>
    </AppPage>
  );
};

const mapStateToProps = state => ({
  emailTemplatesFilter: state.emailTemplatesSendGrid.get('filter'),
  activities: state.eventActivities.getIn(['activitiesOnlyValues', 'emailTemplateActivities', 'target'], List()),
});

/** Email template send grid management component. */
export const EmailTemplateSendGridManagement = memo(
  connect(mapStateToProps, {
    fetchEmailTemplatesSendGrid,
  })(EmailTemplateSendGridManagementComponent),
);
